module.exports = __webpack_public_path__ + "assets/img/cc4d-fr.svg";